<template>
  <div>
    <v-alert
        v-test="{ alert: 'documentExpirationDate' }"
        class="text-center"
        outlined
        :value="showDocumentExpirationDateAlert"
        type="error">
      {{ $t('Срок действия документа, подтверждающего полномочия представителя истек. Для продолжения работы в системе необходимо загрузить новую документ. После одобрения Организатором, доступ к проведению/участию в торгах будет восстановлен.') }}
    </v-alert>
    <v-alert
        :value="showContractExpirationDateAlert"
        class="text-xs-center"
        outlined
        type="error">
      {{ $t('Срок оплаты договора истек.') }}
    </v-alert>
    <v-alert
        :value="showTotalExpirationDateAlert"
        class="text-xs-center"
        outlined
        type="error">
      {{ $t('Срок доступа к системе истек.') }}
    </v-alert>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { CURRENT_USER_EXPIRATIONS_DATES } from '@/constants/store.js'

  export default {
    computed: {
      ...mapState(CURRENT_USER_EXPIRATIONS_DATES.NAMESPACE, {
        documentExpirationDate: state => (state[CURRENT_USER_EXPIRATIONS_DATES.STATE.DOCUMENT_EXPIRATION_DATE] || null),
        contractExpirationDate: state => (state[CURRENT_USER_EXPIRATIONS_DATES.STATE.CONTRACT_EXPIRATION_DATE] || null),
        totalExpirationDate: state => (state[CURRENT_USER_EXPIRATIONS_DATES.STATE.TOTAL_EXPIRATION_DATE] || null)
      }),
      showDocumentExpirationDateAlert () {
        return this.showDateAlert(this.documentExpirationDate)
      },
      showContractExpirationDateAlert () {
        return this.showDateAlert(this.contractExpirationDate)
      },
      showTotalExpirationDateAlert () {
        return this.showDateAlert(this.totalExpirationDate)
      },
      showDateAlert () {
        return (date) => {
          if (!date) {
            return false
          }

          const now = this.$moment()
          return now.isAfter(this.$moment(date))
        }
      }
    },
    created () {
      this.getExpirationDates()
    },
    beforeDestroy () {
      this.clearExpirationDatesAction()
    },
    methods: {
      ...mapActions(CURRENT_USER_EXPIRATIONS_DATES.NAMESPACE, {
        getExpirationDatesAction: CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.GET_EXPIRATION_DATES,
        clearExpirationDatesAction: CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.CLEAR_EXPIRATION_DATES
      }),
      getExpirationDates: async function () {
        try {
          await this.getExpirationDatesAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
